import { useCallback, useEffect } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import dashboardApi from 'services/api/dashboard'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import CreditCardIcon from '../../../components/ReusableComponents/CreditCardIcon/index'
import LoadingIndicator from '../../../components/ReusableComponents/LoadingIndicator'
import { ReactComponent as AddIcon } from './add.svg'
import { ReactComponent as CheckIcon } from './checkIcon.svg'
import styles from './ManagePaymentMethods.module.scss'

const Row = ({ children }) => {
  return <div className={styles.row}>{children}</div>
}

const niceMethodNames = {
  CreditCard: 'Credit card',
  Check: 'E-check',
  ACH: 'E-check'
}

const ManagePaymentMethods = ({ isGroupView }) => {
  const [isLoading, setLoading] = useState(true)
  const [savedPaymentMethods, setSavedPaymentMethods] = useState()
  const [methodInProgress, setMethodInProgress] = useState(null)

  const getData = useCallback(async () => {
    const data = await dashboardApi.getSavedPaymentMethods(isGroupView)
    setSavedPaymentMethods(data)
    setLoading(false)
  }, [isGroupView])

  useEffect(() => {
    getData()
  }, [getData, isGroupView])

  async function handleMakeDefault(id) {
    setMethodInProgress(id)

    await dashboardApi.makePaymentMethodDefaultNew(id, isGroupView).then(() => getData())
  }

  useEffect(() => {
    setMethodInProgress(null)
  }, [savedPaymentMethods])

  return (
    <ConfirmationDialog
      title="Edit payment methods"
      theme="blacklist"
      closeLink="/billing"
      confirmLink="/billing"
      maxWidth={600}
    >
      <div className={styles.wrapper}>
        {isLoading && <LoadingIndicator />}
        {!isLoading && (
          <section>
            <p className={styles.title}>Saved methods</p>
            {savedPaymentMethods.length === 0 && <div>No saved methods found</div>}
            {savedPaymentMethods &&
              savedPaymentMethods.length > 0 &&
              savedPaymentMethods
                .filter(m => m.network !== 'CA')
                .sort(m => (m.method === 'ACH' ? -1 : 1))
                .map(method => (
                  <Row key={method.paymentAccountId}>
                    <div className={styles.ccIcon}>
                      {method.method === 'ACH' ? (
                        <CheckIcon />
                      ) : (
                        <CreditCardIcon type={method.network} />
                      )}
                    </div>
                    <div className={styles.rowContent}>
                      <div className={styles.rowTitle}>
                        {niceMethodNames[method.method]}
                      </div>
                      <div className={styles.rowDesc}>
                        {method.friendlyDisplayName}{' '}
                        {method.method === 'CreditCard' &&
                          `- ${method.accountHolderName} - ${method.expirationDate}`}
                      </div>
                    </div>
                    <div className={styles.rowAction}>
                      {method.isDefaultAccount ? (
                        <span className={styles.defaultMethod}>Default method</span>
                      ) : (
                        <button
                          disabled={methodInProgress === method.paymentAccountId}
                          onClick={() => handleMakeDefault(method.paymentAccountId)}
                        >
                          {methodInProgress === method.paymentAccountId
                            ? 'Updating...'
                            : 'Make default'}
                        </button>
                      )}
                    </div>
                  </Row>
                ))}
            <Link className={styles.addPaymentButton} to={`/billing/addMethod/check`}>
              <AddIcon /> Add payment method
            </Link>
          </section>
        )}
        {/* <section>
          <p className={styles.title}>
            <RepeatIcon />
            Auto payments
          </p>
          <Row>
            <div className={styles.toggleHolder}>
              <Toggle />
            </div>
            <div className={styles.rowContent}>
              <div className={styles.rowTitle}>Enabled</div>
              <div className={styles.rowDesc}>Next payment on May 12</div>
            </div>
          </Row>
        </section> */}
      </div>
    </ConfirmationDialog>
  )
}

export default ManagePaymentMethods
